import { Col, Badge, Row, Modal } from 'antd';
import classNames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import styles from './PersonalPage.module.scss';
import { getNumberWithCommas } from '~/utils';
import config from '~/config';
import LogOutModal from '~/components/form-log-out';
import { handleLogout } from '~/store/actions/UserAction';
import { cartItemsCountSelector } from '~/pages/Cart/selector';
import moment from 'moment';
import LatestBooking from '../Home/components/LatestBooking';
import homeAPI from '~/api/HomeAPI';

const cx = classNames.bind(styles);

const PersonalPage = () => {
    const userInfo = useSelector((state) => state.user.userInfo);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isLogin = userInfo?.id || '';

    const cartItemsCount = useSelector(cartItemsCountSelector);

    const phone_booking = localStorage.getItem('phone_booking');
    const phone = userInfo?.phone || phone_booking;
    const [latestBooking, setLatestBooking] = useState({});
    const [listNameService, setListNameService] = useState([]);

    // Logout
    const [isShowLogoutModal, setIsShowLogoutModal] = useState(false);
    const onCancel = () => {
        setIsShowLogoutModal(false);
    };
    const handleShowLogOut = () => {
        setIsShowLogoutModal(true);
    };
    const onLogOut = () => {
        try {
            dispatch(handleLogout());
            setIsShowLogoutModal(false);
            navigate(config.routes.home);
        } catch (err) {
            // console.log(err);
        }
    };
    const getHomeInformation = async () => {
        try {
            const res = await homeAPI.currentHomeSetting(phone);
            setLatestBooking(res.booking);
            let name_services = [];
            if (res.booking.booking_details?.length) {
                for (const service of res.booking.booking_details) {
                    name_services.push(`${service.title} (x${service.count})`);
                }
            }
            setListNameService(name_services);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getHomeInformation();
        // eslint-disable-next-line
    }, [isLogin]);

    return (
        <div className={cx('mb')}>
            <div className={cx('title_header')}>
                <div className={cx('individual')}>
                    <Row className={cx('header')}>
                        <Col className={cx('title')}>Personal</Col>
                        <Col className={cx('btn_seen_all')}>
                            <Row>
                                <button
                                    className={cx('btn')}
                                    onClick={() => navigate(config.routes.createSchedulePage)}
                                >
                                    <img src={SVGS.IconCalendarWhite} alt="icon-calendar" />
                                    <span className={cx('calendar')}>Schedule</span>
                                </button>
                                <button className={cx('btn')} onClick={() => navigate(config.routes.cart)}>
                                    <Badge
                                        count={cartItemsCount}
                                        showZero
                                        overflowCount={99}
                                        className="mt-3"
                                        style={{
                                            backgroundColor: '#FBBC12',
                                            color: '#333',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <img
                                            src={SVGS.IconCart}
                                            alt=""
                                            onClick={() => {
                                                navigate({
                                                    pathname: '/gio-hang',
                                                });
                                            }}
                                        />
                                    </Badge>
                                </button>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={cx('root')}>
                <div className={cx('individual')}>
                    <Row className={cx('info')}>
                        <Col>
                            <Row
                                justify="center"
                                align="middle"
                                className={cx('avatar_section')}
                                onClick={() => navigate(config.routes.profile)}
                            >
                                <div className={cx('avatar')}>
                                    <img src={userInfo?.avatar || IMAGES.ImagePlaceholder} alt="" />
                                </div>{' '}
                                <div className={cx('tag_type_account')}>
                                    <Row>
                                        <div className={cx('name')}>{userInfo?.fullname || userInfo?.phone}</div>{' '}
                                        {userInfo?.is_collab ? <img src={SVGS.IconChecked} alt="" /> : ''}
                                    </Row>
                                    {userInfo?.is_collab ? (
                                        <div className={cx('account_type')}>Contributor</div>
                                    ) : (
                                        <div className={cx('account_type')}>Member</div>
                                    )}
                                </div>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={cx('box')} align="middle">
                        <div>
                            <img src={SVGS.IconDollarSquare} alt="icon-dollar" />
                        </div>
                        <div className={cx('content')}>
                            <p className={cx('title_content')}>Service Limit</p>
                            <p className={cx('number')}>{getNumberWithCommas(userInfo?.wallet || 0)} d</p>
                            <p className={cx('title_content')}>
                                Expiry:{' '}
                                {userInfo?.expried_wallet && (
                                    <span>
                                        {moment(new Date(parseInt(userInfo?.expried_wallet))).format('DD/MM/YYYY')}
                                    </span>
                                )}
                            </p>
                        </div>
                    </Row>
                    <Row className={cx('box')} align="middle">
                        <div>
                            <img src={SVGS.IconDollarSquare} alt="icon-dollar" />
                        </div>
                        <div className={cx('content')}>
                            <p className={cx('title_content')}>Commission Wallet</p>
                            <p className={cx('number')}>{getNumberWithCommas(userInfo?.wallet_rose || 0)} d</p>
                        </div>
                    </Row>
                    <Row className={cx('box', 'space_between')} align="middle">
                        <div className={cx('payment')} onClick={() => navigate(config.routes.scan)}>
                            <img src={SVGS.IconQRCodeBarcode} alt="icon-dollar" />
                            <p>Scan QR</p>
                        </div>
                        <div className={cx('space')}></div>
                        <div className={cx('payment')} onClick={() => navigate(config.routes.topUp)}>
                            <img src={SVGS.IconEmptyWallet} alt="icon-dollar" />
                            <p>Deposit</p>
                        </div>
                        <div className={cx('space')}></div>
                        <div className={cx('payment')} onClick={() => navigate(config.routes.withdraw)}>
                            <img src={SVGS.IconMoneyReceive} alt="icon-dollar" />
                            <p>Withdraw money</p>
                        </div>
                    </Row>
                </div>
                <Row className={cx('history')}>
                    <span className={cx('title')}>Service booking schedule</span>
                    <div>
                        <span className={cx('more')} onClick={() => navigate(config.routes.historyBooking)}>
                            View booking history
                        </span>
                        <img src={SVGS.ImageChevronRight} alt="" />
                    </div>
                </Row>
                <div style={{ background: 'white' }}>
                    {latestBooking?.id ? (
                        <LatestBooking
                            getHomeInformation={getHomeInformation}
                            latestBooking={latestBooking}
                            listNameService={listNameService}
                            isDesktop={false}
                            personalPage={true}
                        />
                    ) : null}
                </div>
                <Row className={cx('history')}>
                    <span className={cx('text')}>
                        {userInfo?.is_collab ? `Congratulations on becoming an ambassador` : `Scan the QR code to become an ambassador`}
                        <br />
                        Brand of Beauty-ms
                    </span>
                    <div className={cx('center')} onClick={() => navigate(config.routes.shareCollab)}>
                        <img src={SVGS.IconQRCodeWhite} alt="" />
                        <span className={cx('QR_code')}>My QR</span>
                    </div>
                </Row>
                <div className={cx('order')}>
                    <Row className={cx('header')}>
                        <span className={cx('title')}>Order</span>
                        <div
                            onClick={() => {
                                localStorage.setItem('activeKeyHistoryOrder', '');
                                navigate(config.routes.orders);
                            }}
                        >
                            <span className={cx('more')}>See all</span>
                            <img src={SVGS.ImageChevronRight} alt="" />
                        </div>
                    </Row>
                    <Row className={cx('box_status')} align="middle">
                        <Col
                            className={cx('status')}
                            onClick={() => {
                                localStorage.setItem('activeKeyHistoryOrder', 'WAITING');
                                navigate(config.routes.orders);
                            }}
                        >
                            <img src={IMAGES.ImageEmptyWallet} alt="" />
                            <p>Waiting for confirmation</p>
                        </Col>
                        <Col
                            className={cx('status')}
                            onClick={() => {
                                localStorage.setItem('activeKeyHistoryOrder', 'CONFIRMED');
                                navigate(config.routes.orders);
                            }}
                        >
                            <img src={SVGS.IconBox} alt="" />
                            <p>Waiting for delivery</p>
                        </Col>
                        <Col
                            className={cx('status')}
                            onClick={() => {
                                localStorage.setItem('activeKeyHistoryOrder', 'PROCESSING');
                                navigate(config.routes.orders);
                            }}
                        >
                            <img src={IMAGES.ImageDelivery} alt="" />
                            <p>Delivery</p>
                        </Col>
                        <Col
                            className={cx('status')}
                            onClick={() => {
                                localStorage.setItem('activeKeyHistoryOrder', 'COMPLETED');
                                navigate(config.routes.orders);
                            }}
                        >
                            <img src={IMAGES.ImageTruckTick} alt="" />
                            <p>Received</p>
                        </Col>
                        <Col
                            className={cx('status')}
                            onClick={() => {
                                localStorage.setItem('activeKeyHistoryOrder', 'CANCELED');
                                navigate(config.routes.orders);
                            }}
                        >
                            <img src={IMAGES.ImageBagCross} alt="" />
                            <p>Cancelled</p>
                        </Col>
                    </Row>
                </div>
                <div className={cx('nav')}>
                    <Row
                        align="middle"
                        className={cx('nav_item')}
                        onClick={() => navigate(config.routes.historyBooking)}
                    >
                        <img src={SVGS.IconHistory} alt="" />
                        <p>Service booking history</p>
                    </Row>
                    <Row className={cx('nav_item')} onClick={() => navigate(config.routes.historyTopUp)}>
                        <img src={IMAGES.ImagedDollarCircleBold} alt="" />
                        <p>Transaction history</p>
                    </Row>
                    <Row className={cx('nav_item')} onClick={() => navigate(config.routes.historyWithdraw)}>
                        <img src={SVGS.IconSort} alt="" />
                        <p className={cx('nav_item')}>Withdrawal history</p>
                    </Row>
                    <Row className={cx('nav_item')} onClick={() => navigate(config.routes.card)}>
                        <img src={SVGS.IconCreditCard} alt="" />
                        <p>My card</p>
                    </Row>
                    <Row className={cx('nav_item')} onClick={() => navigate(config.routes.downLineCollab)}>
                        <img src={SVGS.IconClipboardList} alt="" />
                        <p>List of downline collaborators</p>
                    </Row>
                </div>
                <div className={cx('nav')}>
                    <Row align="middle" className={cx('nav_item')} onClick={() => navigate(config.routes.editProfile)}>
                        <img src={SVGS.IconIdentification} alt="" />
                        <p>Edit personal information</p>
                    </Row>
                    <Row className={cx('nav_item')} onClick={() => navigate(config.routes.changePass)}>
                        <img src={SVGS.IconLockClosed} alt="" />
                        <p>Change password</p>
                    </Row>
                </div>
                <div className={cx('logout')}>
                    <button className={cx('btn')} onClick={handleShowLogOut}>
                        <img src={SVGS.IconLogout} alt="" />
                        <span>Sign out</span>
                    </button>
                </div>
                {isShowLogoutModal && (
                    <Modal
                        centered
                        visible={isShowLogoutModal}
                        onCancel={onCancel}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={480}
                    >
                        <div style={{ padding: '30px 10px 0px 10px' }}>
                            <LogOutModal onCancel={onCancel} onLogOut={onLogOut} />
                        </div>
                    </Modal>
                )}
            </div>
        </div>
    );
};

export default PersonalPage;
